import { Link } from 'gatsby';
import GatsbyImage from 'gatsby-image';
import * as React from 'react';
import Slider from 'react-slick';

import { Button } from 'components/shared/button';
import { getFluidImage } from 'utils';

import FooterImgSvgUrl from '../images/wegift-blue.url.svg';

import {
  Wrapper,
  Inner,
  Grid,
  GridItem,
  ItemWrapper,
  ItemImg,
  ItemTitle,
  ItemBottomText,
  ContentFooter,
  FooterLeft,
  FooterImg,
  FooterTitle,
  FooterText,
  FooterDescription,
  SliderWrapper,
} from './trusted-logos-block.styles';

export const LogosBlock = (props) => {
  const { items, bottomTitle, bottomDescription, bottomButtonText, bottomButtonLink } = props;

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    autoplay: true,
    autoplaySpeed: 5000,
  };

  return (
    <Wrapper>
      <Inner>
        <Grid
          columns={4}
          gap={0}
          media={{
            sm: { columns: 1 },
          }}
        >
          <GridItem borderRight>
            <ItemWrapper>
              <ItemImg>
                <GatsbyImage
                  style={{
                    width: getFluidImage(items[0].logo.localFile).presentationWidth,
                    maxHeight: 64,
                  }}
                  imgStyle={{
                    objectFit: 'contain',
                    objectPosition: 'left center',
                  }}
                  fluid={getFluidImage(items[0].logo.localFile)}
                  alt={items[0].logo.altText}
                  loading="eager"
                />
              </ItemImg>
              <ItemTitle as="h4">{items[0].title}</ItemTitle>
              <ItemBottomText>{items[0].bottom_text}</ItemBottomText>
            </ItemWrapper>
          </GridItem>
          <GridItem borderRight>
            <ItemWrapper>
              <ItemImg>
                <GatsbyImage
                  style={{
                    width: getFluidImage(items[1].logo.localFile).presentationWidth,
                    maxHeight: 64,
                  }}
                  imgStyle={{
                    objectFit: 'contain',
                    objectPosition: 'top',
                    marginTop: -12,
                  }}
                  fluid={getFluidImage(items[1].logo.localFile)}
                  alt={items[1].logo.altText}
                  loading="eager"
                />
              </ItemImg>
              <ItemTitle as="h4">{items[1].title}</ItemTitle>
              <ItemBottomText>{items[1].bottom_text}</ItemBottomText>
            </ItemWrapper>
          </GridItem>
          <GridItem borderRight>
            <ItemWrapper>
              <ItemImg>
                <GatsbyImage
                  style={{
                    width: getFluidImage(items[2].logo.localFile).presentationWidth,
                    maxHeight: 64,
                  }}
                  imgStyle={{
                    objectFit: 'contain',
                    objectPosition: 'center center',
                  }}
                  fluid={getFluidImage(items[2].logo.localFile)}
                  alt={items[2].logo.altText}
                  loading="eager"
                />
              </ItemImg>
              <ItemTitle as="h4">{items[2].title}</ItemTitle>
              <ItemBottomText>{items[2].bottom_text}</ItemBottomText>
            </ItemWrapper>
          </GridItem>
          <GridItem>
            <ItemWrapper>
              <ItemImg>
                <GatsbyImage
                  style={{
                    width: getFluidImage(items[3].logo.localFile).presentationWidth,
                    maxHeight: 64,
                  }}
                  imgStyle={{
                    objectFit: 'contain',
                    objectPosition: 'center center',
                    marginTop: -20,
                  }}
                  fluid={getFluidImage(items[3].logo.localFile)}
                  alt={items[3].logo.altText}
                  loading="eager"
                />
              </ItemImg>
              <ItemTitle as="h4">{items[3].title}</ItemTitle>
              <ItemBottomText>{items[3].bottom_text}</ItemBottomText>
            </ItemWrapper>
          </GridItem>
        </Grid>
        <SliderWrapper>
          <Slider {...settings}>
            <ItemWrapper>
              <ItemImg>
                <GatsbyImage
                  style={{
                    width: getFluidImage(items[0].logo.localFile).presentationWidth,
                    maxHeight: 64,
                  }}
                  imgStyle={{
                    objectFit: 'contain',
                    objectPosition: 'left center',
                  }}
                  fluid={getFluidImage(items[0].logo.localFile)}
                  alt={items[0].logo.altText}
                  loading="eager"
                />
              </ItemImg>
              <ItemTitle as="h4">{items[0].title}</ItemTitle>
              <ItemBottomText>{items[0].bottom_text}</ItemBottomText>
            </ItemWrapper>
            <ItemWrapper>
              <ItemImg>
                <GatsbyImage
                  style={{
                    width: getFluidImage(items[1].logo.localFile).presentationWidth,
                    maxHeight: 64,
                  }}
                  imgStyle={{
                    objectFit: 'contain',
                    objectPosition: 'top',
                    marginTop: -12,
                  }}
                  fluid={getFluidImage(items[1].logo.localFile)}
                  alt={items[1].logo.altText}
                  loading="eager"
                />
              </ItemImg>
              <ItemTitle as="h4">{items[1].title}</ItemTitle>
              <ItemBottomText>{items[1].bottom_text}</ItemBottomText>
            </ItemWrapper>
            <ItemWrapper>
              <ItemImg>
                <GatsbyImage
                  style={{
                    width: getFluidImage(items[2].logo.localFile).presentationWidth,
                    maxHeight: 64,
                  }}
                  imgStyle={{
                    objectFit: 'contain',
                    objectPosition: 'center center',
                  }}
                  fluid={getFluidImage(items[2].logo.localFile)}
                  alt={items[2].logo.altText}
                  loading="eager"
                />
              </ItemImg>
              <ItemTitle as="h4">{items[2].title}</ItemTitle>
              <ItemBottomText>{items[2].bottom_text}</ItemBottomText>
            </ItemWrapper>
            <ItemWrapper>
              <ItemImg>
                <GatsbyImage
                  style={{
                    width: getFluidImage(items[3].logo.localFile).presentationWidth,
                    maxHeight: 64,
                  }}
                  imgStyle={{
                    objectFit: 'contain',
                    objectPosition: 'center center',
                    marginTop: -20,
                  }}
                  fluid={getFluidImage(items[3].logo.localFile)}
                  alt={items[3].logo.altText}
                  loading="eager"
                />
              </ItemImg>
              <ItemTitle as="h4">{items[3].title}</ItemTitle>
              <ItemBottomText>{items[3].bottom_text}</ItemBottomText>
            </ItemWrapper>
          </Slider>
        </SliderWrapper>
        <ContentFooter>
          <FooterLeft>
            <FooterImg
              src={FooterImgSvgUrl}
              width={80}
              height={80}
              alt="WeGift Logo"
              loading="lazy"
              aria-hidden
            />
            <FooterText>
              <FooterTitle as="h3">{bottomTitle}</FooterTitle>
              <FooterDescription>{bottomDescription}</FooterDescription>
            </FooterText>
          </FooterLeft>
          <Button component={Link} theme="fill" to={bottomButtonLink}>
            {bottomButtonText}
          </Button>
        </ContentFooter>
      </Inner>
    </Wrapper>
  );
};
